module.exports = __webpack_public_path__ + "media/Take Me To Your Home (电影《我要我们在一起》配乐).3b809dc0.mp3";